import {formatEventOccurrenceTime, formatMoney} from "../../../js/formatters";

export const createAnnouncementElement = (json: any): HTMLElement | null => {
    const template = document.getElementById('announcement-template') as HTMLTemplateElement;
    if (!template) {
        return null
    }

    const clone = template.content.cloneNode(true) as HTMLElement;

    if (json.thumb_urls?.length) {
        const headerImage = clone.querySelector<HTMLImageElement>('[data-header-image]');
        if (headerImage) headerImage.src = json.thumb_urls[0];
    } else {
        const headerImageContainer = clone.querySelector<HTMLDivElement>('[data-header-image-container]');
        if (headerImageContainer) headerImageContainer.remove();
    }

    const announcementLink = clone.querySelector<HTMLLinkElement>('[data-announcement-path]');
    if (announcementLink) announcementLink.href += `/${json.id}`;

    const typeNamePlaceholder = clone.querySelector('[data-type-name]');
    if (typeNamePlaceholder) typeNamePlaceholder.textContent = json.event_type?.name;

    const sportNamePlaceholder = clone.querySelector('[data-sport-name]');
    if (sportNamePlaceholder) sportNamePlaceholder.textContent = json.sport?.name;

    const metroStationsPlaceholder = clone.querySelector('[data-metro-stations]');
    if (metroStationsPlaceholder) metroStationsPlaceholder.textContent = json.metro_stations?.length ? `м. ${json.metro_stations}` : null;

    const participantsLevelsPlaceholder = clone.querySelector('[data-participants-levels]');
    if (participantsLevelsPlaceholder) participantsLevelsPlaceholder.textContent = json.participants_levels?.map((pl: { name: string }) => pl.name).join("/");

    const timePlaceholder = clone.querySelector('[data-time]');
    if (timePlaceholder) timePlaceholder.textContent = formatEventOccurrenceTime(json.start_time, json.end_time);

    const participantsTypesPlaceholder = clone.querySelector('[data-participants-types]');
    if (participantsTypesPlaceholder) participantsTypesPlaceholder.textContent = json.participants_type?.name

    const titlePlaceholder = clone.querySelector('[data-title]');
    if (titlePlaceholder) titlePlaceholder.innerHTML = json.title;

    const shortDescriptionPlaceholder = clone.querySelector('[data-short-description]');
    if (shortDescriptionPlaceholder) shortDescriptionPlaceholder.innerHTML = json.short_description;

    const minCostPlaceholder = clone.querySelector('[data-min-cost]');
    if (minCostPlaceholder) minCostPlaceholder.textContent = formatMoney(json.min_cost);

    return clone;
}